import React, { FC, useCallback } from 'react';
import { getRoutePath } from '../../Routes/routePaths';
import { AppError } from '../../Generic/AppError';

type ErrorContentProps = {
  code?: string;
  message?: string;
  subtitle?: string;
  fullHeight?: boolean;
  btnLabel?: string;
  retryBtnLabel?: string;
  onRetry?: () => void;
  onClickBtn?: () => void;
  className?: string;
  shouldShowButton?: boolean;
  isFullwidth?: boolean;
  isNumericCode?: boolean;
  isPaddedHorizontally?: boolean;
  shouldShowLottie?: boolean
};

// TODO mobile layout
const ErrorContent: FC<ErrorContentProps> = ({
  code,
  message,
  subtitle,
  btnLabel = 'Back to home',
  onClickBtn,
  retryBtnLabel,
  onRetry,
  className,
  fullHeight,
  shouldShowButton = true,
  isFullwidth = false,
  isNumericCode = true,
  isPaddedHorizontally = false,
  shouldShowLottie = true,
}) => {
  const onClick = useCallback(() => {
    if (onClickBtn) {
      onClickBtn();
    } else {
      window.location.href = getRoutePath({ routeKey: '' });
    }
  }, [onClickBtn]);

  return (
    <AppError
      code={code}
      message={message}
      subtitle={subtitle}
      btnLabel={btnLabel}
      onClickBtn={onClick}
      retryBtnLabel={retryBtnLabel}
      onRetry={onRetry}
      shouldShowButton={shouldShowButton}
      className={className}
      isFullwidth={isFullwidth}
      fullHeight={fullHeight}
      isNumericCode={isNumericCode}
      isPaddedHorizontally={isPaddedHorizontally}
      shouldShowLottie={shouldShowLottie}
    />
  );
};

export { ErrorContent };
